var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("fallback")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-column-select", {
                attrs: {
                  model: _vm.model,
                  "is-filter": false,
                  "is-server-column": "",
                },
                model: {
                  value: _vm.v,
                  callback: function ($$v) {
                    _vm.v = $$v
                  },
                  expression: "v",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }